import { render, staticRenderFns } from "./SectionProperties.vue?vue&type=template&id=72a3b22e"
import script from "./SectionProperties.vue?vue&type=script&lang=js"
export * from "./SectionProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports